import { Navigate } from "react-router-dom";

import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import {
  MainKpiForm,
  MainKpiTimeline,
  MainKpiReview,
  AddKpiForm,
  EditKpiForm,
  DetailKpiForm,
  KpiTimelinePeriodStep,
  KpiEmployeesStep,
  KpiAssessmentStep,
  AddKpiTimeline,
  EditKpiTimeline,
  DetailKpiReview,
  DetailKpiReviewEmployee,
} from "./pages";

const kpiRoutes = [
  {
    path: "/kpi",
    element: <Navigate to="/kpi/form" replace />,
    breadcrumb: () => <TranslationBreadcrumb name="KPI" />,
  },
  {
    path: "/kpi/form",

    element: (
      <ProtectedRoute name="kpi_form">
        <MainKpiForm />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.form" />,
  },
  {
    path: "/kpi/form/add",
    element: <AddKpiForm />,
    breadcrumb: () => <TranslationBreadcrumb name="kpi.add_form" />,
  },
  {
    path: "/kpi/form/duplicate",
    element: (
      <ProtectedRoute name="kpi_form_add">
        <AddKpiForm />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.duplicate_form" />,
  },
  {
    path: "/kpi/form/:id/edit",
    element: (
      <ProtectedRoute name="kpi_form_edit">
        <EditKpiForm />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.edit_form" />,
  },
  {
    path: "/kpi/form/:id/detail",
    element: (
      <ProtectedRoute name="kpi_form">
        <DetailKpiForm />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.form_detail" />,
  },
  {
    path: "/kpi/timeline",
    element: (
      <ProtectedRoute name="kpi_timeline">
        <MainKpiTimeline />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.timeline" />,
  },
  {
    path: "/kpi/timeline/add",
    element: (
      <ProtectedRoute name="kpi_timeline_add">
        <AddKpiTimeline />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.add_timeline" />,
    children: [
      {
        path: "/kpi/timeline/add/period",
        element: <KpiTimelinePeriodStep />,
        breadcrumb: null,
      },
      {
        path: "/kpi/timeline/add/period/:id",
        element: <KpiTimelinePeriodStep />,
        breadcrumb: null,
      },
      {
        path: "/kpi/timeline/add/employees/:id",
        element: <KpiEmployeesStep />,
        breadcrumb: null,
      },
      {
        path: "/kpi/timeline/add/assessment/:id",
        element: <KpiAssessmentStep />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/kpi/timeline/edit",
    element: (
      <ProtectedRoute name="kpi_timeline_edit">
        <EditKpiTimeline />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.edit_timeline" />,
    children: [
      {
        path: "/kpi/timeline/edit/period/:id",
        element: <KpiTimelinePeriodStep />,
        breadcrumb: null,
      },
      {
        path: "/kpi/timeline/edit/period/:id",
        element: <KpiTimelinePeriodStep />,
        breadcrumb: null,
      },
      {
        path: "/kpi/timeline/edit/employees/:id",
        element: <KpiEmployeesStep />,
        breadcrumb: null,
      },
      {
        path: "/kpi/timeline/edit/assessment/:id",
        element: <KpiAssessmentStep />,
        breadcrumb: null,
      },
    ],
  },
  {
    path: "/kpi/review",
    element: (
      <ProtectedRoute name="kpi_review">
        <MainKpiReview />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.review" />,
  },
  {
    path: "/kpi/review/detail/:id",
    element: (
      <ProtectedRoute name="kpi_review">
        <DetailKpiReview />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.review_detail" />,
  },
  {
    path: "/kpi/review/detail/:id/employee/:employeeId",
    element: (
      <ProtectedRoute name="kpi_review_edit">
        <DetailKpiReviewEmployee />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="kpi.employee_review" />,
  },
];

export default kpiRoutes;
